import {Injectable} from '@angular/core';
import {Group} from 'konva/lib/Group';
import {Text} from 'konva/lib/shapes/Text';
import {IConnectorsEdges, ITagretsNodes, TGraphType} from '../models/graph-kn.model-interfaces';
import {Layer} from 'konva/lib/Layer';
import {GraphKnDataService} from './graph-kn.data.service';
import {TARGET_TYPES_WITH_RESTRICTIONS} from '../models/graph-kn.cm.model-const';
import {Rect} from 'konva/lib/shapes/Rect';
import {AlertService} from '../../../services/notify/alert.service';
import {TranslateService} from '@ngx-translate/core';
import {GraphKnRestrictionsService} from './graph-kn.restrictions.service';
import {ArrayOfTwo, GraphKnHelperService} from './graph-kn.helpers.service';
import {MIN_ARROW_LENGTH} from '../models/graph-kn.cm.arrows-model-const';
import {Vector2d} from 'konva/lib/types';
import {GAP_BW_ROWS, LEFT_MARGIN_LAYER, TOP_MARGIN_LAYER} from '../models/graph-kn.cm.layers-model-const';
import {CONTRACT_LAYER_ID, TLayerIDs} from '../models/graph-kn.cm-api-models';
import { RectModelsMap } from '../styles/graph-node-rect-model';
import { Path } from 'konva/lib/shapes/Path';
import { Circle } from 'konva/lib/shapes/Circle';
import { Arrow } from 'konva/lib/shapes/Arrow';
import { Line } from 'konva/lib/shapes/Line';
import { LayOutService } from './graph-kn.layout.service';
@Injectable({
    providedIn: 'root'
})
export class GraphKnMoveStepRMService {
    private nodeGroupsEnv!: Group [];
    private nodesSwapped!: boolean;
    private nodeSwappedId!: number;
    private dragGroupX!: number;

    constructor(
        private knDataService: GraphKnDataService,
        private knRestrictionsService: GraphKnRestrictionsService,
        private knHelperService: GraphKnHelperService,
        private alertService: AlertService,
        private translateService: TranslateService,
        private layOutService:LayOutService
    ) {
    }

    dragStartContract(dragGroup: Group, layer: Layer) {
        if (this.nodeIsDraggble(dragGroup) === false) {
            let errMsg = this.translateService.instant('ALERTS.WAIT_RESTRICTION_DRAG_FORBIDDEN');
            this.blockDragAlert([dragGroup.attrs.id], errMsg, dragGroup.children as Group[])
            dragGroup.stopDrag()
        }
        this.nodesSwapped = false;
        this.knDataService.dragGroupId = dragGroup.attrs.data.id;
        this.knDataService.dragGroupIndex = dragGroup.attrs.data.id;
        this.dragGroupX = dragGroup.attrs.x
        let nodes = layer.children.filter(el => (el instanceof Group) && el.attrs.draggable) as Group[]
        this.nodeGroupsEnv = new Array(nodes.length-1)
        nodes.forEach(node => this.nodeGroupsEnv[+node.attrs.data.contract_step_data.stepNumber-1] = node);
    }

    dragMoveContract(
        connectorsEdges: IConnectorsEdges[], nodeGroup: Group, 
        targetsNodes: ITagretsNodes[], graphType: TGraphType, layer: Layer
    ): boolean {
        let stepsIntersects = false
        for (let index = 0; index <= this.nodeGroupsEnv.length - 1; index++) {
            let nodeToReplace = this.nodeGroupsEnv[index]
            let dragNodeYinterval = [nodeGroup.y(), nodeGroup.y() + nodeGroup.attrs.dimensions.height] as ArrayOfTwo;
            let nodeReplaceYinterval = [nodeToReplace.attrs.y, nodeToReplace.attrs.y + nodeToReplace.attrs.dimensions.height] as ArrayOfTwo;
            
            let dragNodeXinterval = [nodeGroup.x(), nodeGroup.x() + nodeGroup.attrs.dimensions.width] as ArrayOfTwo;
            let nodeReplaceXinterval = [nodeToReplace.attrs.x, nodeToReplace.attrs.x + nodeToReplace.attrs.dimensions.width] as ArrayOfTwo;
            let intersecXint:boolean = this.knHelperService.intersect2Ranges(dragNodeXinterval, nodeReplaceXinterval, 0.1);
            let intersecYint:boolean = this.knHelperService.intersect2Ranges(dragNodeYinterval, nodeReplaceYinterval, 0.3);
            let ignoredSteps = [this.knDataService.dragGroupId,this.nodeSwappedId ]
            intersecXint && intersecYint? stepsIntersects = true : null;
            if (ignoredSteps.includes (this.nodeGroupsEnv[index].attrs.id ) === false &&  intersecXint && intersecYint) {
                let dragGroupIndex = this.nodeGroupsEnv.findIndex(el => el.attrs.id === this.knDataService.dragGroupId);
                let swappingGroup = [
                    {
                        guid: this.nodeGroupsEnv[dragGroupIndex].attrs.id,
                        index: dragGroupIndex,
                    },
                    {
                        guid: this.nodeGroupsEnv[index].attrs.id,
                        index: index ,
                    }
                ]
                this.nodesSwapped = true;
                this.nodeSwappedId = this.nodeGroupsEnv[index].attrs.id
                let checkResctriction = this.knRestrictionsService.checkResctrictionDrag(swappingGroup, CONTRACT_LAYER_ID, this.nodeGroupsEnv)
                if (checkResctriction.blocked) {
                    this.blockDragByRestriction(dragGroupIndex, nodeGroup, layer, connectorsEdges, graphType);
                    let restrictionsGuids = [checkResctriction.restrictionGroup.guidStep, ...checkResctriction.restrictionGroup.guidsLinkedSteps]
                    this.blockDragAlert(restrictionsGuids, checkResctriction.msg, this.nodeGroupsEnv)
                    this.nodeSwappedId = 0;
                    return true
                } 
                let newXPostion = this.nodeGroupsEnv[index].attrs.x;
                this.dragGroupX = this.nodeGroupsEnv[index].attrs.x

                this.nodeGroupsEnv = this.knHelperService.swapTwoElements(this.nodeGroupsEnv, dragGroupIndex, index);
                [dragGroupIndex].forEach(i => {
                    let newPositions = this.calcNodePositions(i, undefined, 'contractLayer', 0);
                    this.nodeGroupsEnv[i].x(newPositions.x)
                    this.nodeGroupsEnv[i].y(newPositions.y)
                })
                this.dragGroupX = newXPostion
                this.updateNodesStepNumber();
                this.createNewNodesArrayNewOrder(layer);
                this.updateEdgesNewOrder(connectorsEdges)
                nodeGroup.moveToTop();
                 this.updateContractEdges(connectorsEdges,layer,graphType)
                return true
            }
        }
        stepsIntersects? null: this.nodeSwappedId = 0;
        return false
    }

    blockDragByRestriction(
        dragGroupIndex: number,
        nodeGroup: Group, layer: Layer,
        connectorsEdges: IConnectorsEdges[],
        graphType: TGraphType,
    ) {
        this.nodesSwapped = false;
        nodeGroup.stopDrag()
        let calcPos = this.calcNodePositions(dragGroupIndex, undefined, CONTRACT_LAYER_ID, 0)
        nodeGroup.x(calcPos.x)
        nodeGroup.y(calcPos.y)
        this.updateContractEdges(connectorsEdges,layer,graphType)
    }

    dragEndContract(dragGroup: Group, layer: Layer, targetsNodes: ITagretsNodes[], connectorsEdges: IConnectorsEdges[], graphType: TGraphType) {
        let newIndex = this.nodeGroupsEnv.findIndex(el=>el.attrs.id===this.knDataService.dragGroupId)
        this.knDataService.dragGroupId = ''
        if (this.nodesSwapped) {
            dragGroup.y(targetsNodes[newIndex].y)
            dragGroup.x(this.dragGroupX)
            this.updateEdgesNewOrder(connectorsEdges)
            let newStepsOrder = this.nodeGroupsEnv.map((step, index) => {
                console.log('step.attrs',step.attrs)
                
                return {guid: step.attrs.id, sort_index: index,name:step.attrs.data.label}
            }).sort((a, b) => a.sort_index - b.sort_index)
            this.knDataService.lastContractStepId = newStepsOrder[newStepsOrder.length - 1].guid
            this.nodeSwappedId = 0
            this.updateContractEdges(connectorsEdges,layer,graphType)
            this.knDataService.subOnStepsOrderChanged$.next(newStepsOrder)
        }
    }
    updateContractEdges(connectorsEdges:IConnectorsEdges[],graphLayer:Layer,layerId:TLayerIDs) {
        let graphSettings = this.knDataService.layoutDagreSettings.get(layerId)!
        connectorsEdges.forEach(connector => {
                let fromNode = graphLayer.findOne('#' + connector.from) as Group;
                let toNode = graphLayer.findOne('#' + connector.to) as Group;
                let edgePath = graphLayer.findOne('#' + connector.id + '_edge_path') as Path|Line
                let edgePointer = graphLayer.findOne('#' + connector.id + '_edge_pointer') as Circle|Rect|Arrow
                edgePath? this.layOutService.updateLocalEdges(fromNode, toNode, connector, edgePath as Path, edgePointer, graphSettings) : null
        });
    }
    nodeIsDraggble(nodeGroup: Group): boolean {
        if (TARGET_TYPES_WITH_RESTRICTIONS.includes(nodeGroup.attrs.data.step?.target?.target_type) === false) {
            return true
        } else {
            return this.knDataService.loadingIds.length === 0
        }
    }

    blockDragAlert(guids: string [], msg: string, groups: Group[]) {
        guids.forEach(guid => {
            let node = (groups.find(el => el.attrs.id === guid)?.children.filter(ch => ch instanceof Rect)[0] as Rect);
            if (node) {
                node.stroke('red')
                setInterval(() => node.stroke(null), 3000);
            }
        })
        this.alertService.setAlert(msg, 'blue', 4)
    }

    updateNodesStepNumber() {
        this.nodeGroupsEnv.forEach((el, index) => {
            el.attrs.data.stepNumber = index + 1;
            el.attrs.data?.contract_step_data?.stepNumber? el.attrs.data.contract_step_data.stepNumber = index + 1 : null;
            (el.children.find(child => child.attrs.id?.includes('text_number')) as unknown as Text).text((index + 1).toString())
        })
    }

    createNewNodesArrayNewOrder(layer: Layer) {
        let nodes = layer.children.filter(el => (el instanceof Group) && el.attrs.draggable) as Group[]
        this.nodeGroupsEnv = new Array(nodes.length)
        nodes.forEach(node => this.nodeGroupsEnv[+node.attrs.data.contract_step_data.stepNumber - 1] = node)
    }

    updateEdgesNewOrder(edges: IConnectorsEdges[]) {
        for (let i = 0; i < this.nodeGroupsEnv.length - 1; i++) {
            edges[i].from = this.nodeGroupsEnv[i].attrs.id;
            edges[i].to = this.nodeGroupsEnv[i + 1].attrs.id;
        }
    }

    calcNodePositions(nodeIndex: number, positionBP: Vector2d | undefined, layerID: TGraphType, topNodeYpos: number): Vector2d {
        let rectModel = RectModelsMap.get('contractStep')
        let layerIndex = 1;
        let posXLineGraph: number =
            ((this.knDataService.nodeWidth || rectModel!.width!) + MIN_ARROW_LENGTH)
            * (nodeIndex - this.knDataService.nodeCountPerStage * Math.floor(nodeIndex / this.knDataService.nodeCountPerStage))

        let pos = positionBP
        let posYLineGraph: number = rectModel!.height! * TOP_MARGIN_LAYER + rectModel!!.height! * (1 + GAP_BW_ROWS) * Math.floor(nodeIndex / this.knDataService.nodeCountPerStage)
        //let posYTaskGraph: number = (pos?.y || 0) - topNodeYpos
        let posYTaskGraph: number = (pos?.y || 0) - rectModel!.height!/2
        return {
            x: layerID === 'bpLayer' ? (pos?.x || 0) - rectModel!.width!/2  : (posXLineGraph + LEFT_MARGIN_LAYER * ((layerIndex || 0) + 1)),
            y: layerID === 'bpLayer' ? posYTaskGraph : posYLineGraph
        }
    }
}